import { Link } from 'react-router-dom';
import { Users, CalendarDays, MapPin, ArrowUpRight, BookOpen, Brain, Network } from 'lucide-react';
import { Badge } from './ui/badge';
import { AdmNotice } from './AdmPreparation';
import CourseCover from './CourseCover';
import { deadlineState, availabilityLabel } from '../lib/coursePresentation';

export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    return new Date(d + (d.length === 10 ? 'T00:00:00' : '')).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch { return d; }
};

export const statusStyle = (s) => ({
  APERTO: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  IN_SCADENZA: 'bg-amber-50 text-amber-700 border-amber-200',
  CHIUSO: 'bg-slate-100 text-slate-500 border-slate-200',
}[s] || 'bg-slate-100 text-slate-600');

export const statusLabel = (s) => ({ APERTO: 'Aperto', IN_SCADENZA: 'In scadenza', CHIUSO: 'Chiuso', PLANNING: 'Percorso di preparazione' }[s] || s);

export default function ContestCard({ contest }) {
  const calendar = deadlineState(contest);
  return (
    <div>
      <Link to={`/concorsi/${contest.contest_id}`} data-testid={`contest-card-${contest.contest_id}`}
        className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_10px_35px_-30px_rgba(7,24,63,.5)] transition hover:-translate-y-1 hover:border-indigo-200 hover:shadow-[0_22px_45px_-30px_rgba(51,69,198,.45)]">
        <CourseCover contest={contest} />
        <div className="flex flex-1 flex-col p-5 sm:p-6">
          <div className="mb-5 flex items-center justify-between gap-3">
            <Badge className={`${statusStyle(calendar.code)} border text-xs`} data-testid={`contest-status-${contest.contest_id}`}>
              {calendar.label}
            </Badge>
            <span className="text-xs font-semibold text-slate-500">{availabilityLabel(contest)}</span>
          </div>
          <p className="text-xs font-bold uppercase tracking-[0.13em] text-brand">{contest.ente || contest.category}</p>
          <h3 className="mt-2 min-h-[3.5rem] font-display text-lg font-bold leading-snug text-brand-dark transition-colors group-hover:text-brand">
            {contest.title}
          </h3>
          <AdmNotice contest={contest} compact />
          <div className="mt-5 grid grid-cols-2 gap-2 text-xs text-slate-600">
            <span className="inline-flex items-center gap-1.5"><MapPin size={13} />{contest.region}</span>
            {contest.positions != null && <span className="inline-flex items-center gap-1.5"><Users size={13} />{contest.positions} {contest.positions === 1 ? 'posto' : 'posti'}</span>}
            {contest.deadline && <span className="col-span-2 inline-flex items-center gap-1.5"><CalendarDays size={13} />Termine riportato: {fmtDate(contest.deadline)}</span>}
          </div>
          {(contest.total_pages || contest.total_maps || contest.quiz_count) && <div className="mt-5 flex flex-wrap gap-3 border-t border-slate-100 pt-4 text-xs font-semibold text-slate-500">{contest.total_pages ? <span className="inline-flex gap-1"><BookOpen size={13}/>{contest.total_pages} pagine</span> : null}{contest.total_maps ? <span className="inline-flex gap-1"><Network size={13}/>{contest.total_maps} mappe</span> : null}{contest.quiz_count ? <span className="inline-flex gap-1"><Brain size={13}/>{contest.quiz_count} quiz</span> : null}</div>}
          <div className="mt-auto flex items-end justify-between border-t border-slate-100 pt-5">
            <div><p className="text-[11px] text-slate-500">Acquisto singolo</p><span className="font-display text-xl font-bold text-brand-dark" data-testid={`contest-price-${contest.contest_id}`}>€ {Number(contest.price).toFixed(2)}</span></div>
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-light text-brand transition group-hover:bg-brand group-hover:text-white"><ArrowUpRight size={18} /></span>
          </div>
        </div>
      </Link>
    </div>
  );
}
